import { h } from 'preact'
export const StarFull = () => {
    return (
      <svg class="icon icon-full-star" viewBox="0 0 15 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <g id="WIP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="Artboard" transform="translate(-777.000000, -263.000000)" fill="currentColor">
                  <polygon id="star-full" points="784.333333 273.472777 779.924944 276.567627 781.506054 271.418639 777.200409 268.182373 782.585979 268.094973 784.333333 263 786.080688 268.094973 791.466257 268.182373 787.160612 271.418639 788.741723 276.567627"></polygon>
              </g>
          </g>
      </svg>
    )
}
